import React from "react";
import PropTypes from "prop-types";
import { Col, Grid, Row } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { useLiveSessionScheduleFormActions } from "../../customHooks";
import * as ScheduleFormFields from "../../constants/liveSessionScheduleFormFields";
import { LiveSessionScheduleDateInput } from "./LiveSessionScheduleDateInput";
import { LiveSessionScheduleDescriptionInput } from "./LiveSessionScheduleDescriptionInput";
import { LiveSessionScheduleFooter } from "./LiveSessionScheduleFooter";
import { LiveSessionScheduleEmailAlert } from "./LiveSessionScheduleEmailAlert";
import { LiveSessionScheduleLanguageInput } from "./LiveSessionScheduleLanguageInput";
import { LiveSessionScheduleTimeInput } from "./LiveSessionScheduleTimeInput";
import { LiveSessionScheduleTips } from "./LiveSessionScheduleTips";
import { LiveSessionScheduleTitle } from "./LiveSessionScheduleTitle";
import { LiveSessionScheduleTitleInput } from "./LiveSessionScheduleTitleInput";

export const LiveSessionScheduleContent = ({
  initialData,
  numberOfStudents,
  loading,
  onCancel,
  onSubmit,
}) => {
  const {
    scheduleFormState,
    updateScheduleFormTitleInput,
    updateScheduleFormDateInput,
    updateScheduleFormTimeInput,
    updateScheduleFormLanguageInput,
    updateScheduleFormDescriptionInput,
  } = useLiveSessionScheduleFormActions({ initialData });

  const handleSubmitForm = () => {
    if (!scheduleFormState.isFormInvalid) {
      onSubmit({
        liveSession: [
          ScheduleFormFields.TITLE,
          ScheduleFormFields.SCHEDULED_AT,
          ScheduleFormFields.LANGUAGE,
          ScheduleFormFields.DESCRIPTION,
        ].reduce((accumulator, field) => {
          accumulator[field] = scheduleFormState.fields[field].value;
          return accumulator;
        }, {}),
      });
    }
  };

  return (
    <Row>
      <Col width={[1, 3 / 4, 3 / 4]}>
        <Grid width="100%">
          <LiveSessionScheduleTitle />
          <LiveSessionScheduleTitleInput
            disabled={loading}
            onChange={updateScheduleFormTitleInput}
            /* eslint-disable-next-line react/jsx-props-no-spreading */
            {...scheduleFormState.fields[ScheduleFormFields.TITLE]}
          />
          <LiveSessionScheduleDateInput
            disabled={loading}
            onChange={updateScheduleFormDateInput}
            /* eslint-disable-next-line react/jsx-props-no-spreading */
            {...scheduleFormState.fields[ScheduleFormFields.DATE]}
          />
          <LiveSessionScheduleTimeInput
            disabled={loading}
            onChange={updateScheduleFormTimeInput}
            /* eslint-disable-next-line react/jsx-props-no-spreading */
            {...scheduleFormState.fields[ScheduleFormFields.TIME]}
          />
          <LiveSessionScheduleLanguageInput
            disabled={loading}
            onChange={updateScheduleFormLanguageInput}
            /* eslint-disable-next-line react/jsx-props-no-spreading */
            {...scheduleFormState.fields[ScheduleFormFields.LANGUAGE]}
          />
          <LiveSessionScheduleDescriptionInput
            disabled={loading}
            onChange={updateScheduleFormDescriptionInput}
            /* eslint-disable-next-line react/jsx-props-no-spreading */
            {...scheduleFormState.fields[ScheduleFormFields.DESCRIPTION]}
          />
          <LiveSessionScheduleEmailAlert numberOfStudents={numberOfStudents} />
          <LiveSessionScheduleFooter
            cancelDisabled={loading}
            submitDisabled={loading || scheduleFormState.isFormInvalid}
            onCancel={onCancel}
            onSubmit={handleSubmitForm}
          />
        </Grid>
      </Col>
      <Col width={[1, 1 / 4, 1 / 4]}>
        <LiveSessionScheduleTips />
      </Col>
    </Row>
  );
};

LiveSessionScheduleContent.propTypes = {
  initialData: PropTypes.shape({}),
  numberOfStudents: PropTypes.number,
  loading: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

LiveSessionScheduleContent.defaultProps = {
  initialData: null,
  numberOfStudents: 0,
  loading: false,
};

export default LiveSessionScheduleContent;
